import React from "react";
import PropTypes from "prop-types";

import Image from "../../../../../common/image";

import './gallery.scss';

function Gallery(props) {
	const { images, onSelectTemplate, selectedTemplate } = props;

	const isSelectedTemplate = (imageId)=> {return selectedTemplate === imageId};

	return (
		<div className="gallery">
			{images.map((image) =>
				<div onClick={()=>onSelectTemplate(image)} key={'gallery-'+image.id}>
					<Image src={image.url}
						   className={(isSelectedTemplate(image.id) ? 'active': '')}>
						<img style={{width:'100%', height:'100%'}} alt="" />
					</Image>
				</div>
			)}
		</div>
	)
}

Gallery.propTypes = {
	images: PropTypes.array.isRequired,
	onSelectTemplate: PropTypes.func.isRequired,
	selectedTemplate: PropTypes.number.isRequired
};

export default Gallery;
